export default __webpack_public_path__ + "static/impact-ready-shadow-50697bbf624b076bc5c6261c4f25c2c0.svg";